import './TemplateCard.css';
import { Card, CardMedia, Typography, Button } from '@mui/material';
import SquareCircle from './customLoader/SquareCircle';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import InstanceControls from './InstanceControls';

const TemplateCard = ({
    logo,
    title,
    description,
    onClick,
    loadingCards = [],
    createdEnvs = [],
    templateName,
    documentationLink,
    isFree,
    instance,
    timeAgo,
    handleDeleteEnv,
    refreshEnvironment,
    handleResume,
    handlePause,
    handleStart,
}) => {
    const isCardLoading = loadingCards.includes(templateName);
    const isEnvCreated = createdEnvs.includes(templateName);

    return (
        <Card
            className={`template-card${isFree ? '' : ' not-free-card'} responsive-template-card`}
            sx={{
                height: '220px',
                flexShrink: 0,
                borderRadius: '8px',
                border: '0.936px solid rgba(255, 255, 255, 0.20)',
                background: 'rgba(26, 29, 33, 0.40)',
                position: 'relative',
                transition: 'transform 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '15px',
                boxSizing: 'border-box',
                overflow: 'hidden',
                justifyContent: 'flex-start',
            }}
        >
            {/* Top row: Logo, title, description */}
            <div className="template-card-top-row" style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 16, marginBottom: 8 }}>
                <CardMedia component="img" alt={title} image={logo} sx={{ width: 64, height: 64, borderRadius: 2}} />
                <div className="template-card-main-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', flex: 1 }}>
                    <Typography variant="h6" color="white">{title}</Typography>
                    <Typography
                        variant="body2"
                        className="template-card-description"
                    >
                        {description}
                    </Typography>
                    {documentationLink && (
                        <a
                            href={documentationLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#fff', fontSize: '12px', paddingTop: '10px' }}
                        >
                            docs&nbsp;
                            <NorthEastIcon fontSize="12px" style={{ fontSize: '14px', verticalAlign: 'middle' }} />
                        </a>
                    )}
                </div>
            </div>
            {/* Main content below top row */}
            <div className="template-card-content">
                <div className="template-card-actions">
                    {!isFree ? (
                        <div style={{ paddingTop:'20px'}}>
                        <button
                            variant="contained"
                            disabled
                            style={{
                                background: 'rgba(26, 29, 33, 0.40)',
                                textAlign: 'center',
                                fontSize: '10.238px',
                                fontStyle: 'normal',
                                fontFamily: 'Plus Jakarta Sans, sans-serif',
                                fontWeight: 700,
                                lineHeight: '150%',
                                border: '0.936px solid rgba(255, 255, 255, 0.20)',
                                borderRadius: '5px',
                                width: '200px',
                                height: '40px',
                                color: '#28C1F9',
                                textTransform:'uppercase',
                                transition: 'transform 0.3s ease-in-out',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                },
                            }}
                        >
                            Coming Soon
                        </button>
                        </div>
                    ) : isCardLoading ? (
                        <div style={{ paddingTop:'20px'}}>
                        <Button
                            variant="outline"
                            sx={{
                                background: 'rgba(26, 29, 33, 0.40)',
                                color: '#FFF',
                                textAlign: 'center',
                                fontSize: '10.238px',
                                fontStyle: 'normal',
                                fontWeight: 700,
                                lineHeight: '150%',
                                border: '0.936px solid rgba(255, 255, 255, 0.20)',
                                borderRadius: '5px',
                                width: '200px',
                                height: '40px',
                                transition: 'transform 0.3s ease-in-out',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                },
                            }}
                        >
                            <SquareCircle />
                        </Button>
                        </div>
                    ) : !instance ? (
                        <div style={{ paddingTop: '20px' }}>
                            <Button
                                variant="outline"
                                onClick={onClick}
                                sx={{
                                    background: 'rgba(26, 29, 33, 0.40)',
                                    color: '#FFF',
                                    textAlign: 'center',
                                    fontSize: '10.238px',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    lineHeight: '150%',
                                    border: '0.936px solid rgba(255, 255, 255, 0.20)',
                                    borderRadius: '5px',
                                    width: '200px',
                                    height: '40px',
                                    transition: 'transform 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'scale(1.05)',
                                    },
                                }}
                                endIcon={<ChevronRightIcon style={{ fontSize: '10px', background: '#00FF85', borderRadius: '53.625px', color: 'black' }} />}
                            >
                                Create
                            </Button>
                        </div>
                    ) : (
                        <div className="template-card-instance-controls">
                            <InstanceControls
                                instance={instance}
                                timeAgo={timeAgo}
                                handleDeleteEnv={handleDeleteEnv}
                                refreshEnvironment={refreshEnvironment}
                                handleResume={handleResume}
                                handlePause={handlePause}
                                handleStart={handleStart}
                            />
                        </div>
                    )}
                </div>
            </div>
           
        </Card>
    );
};

export default TemplateCard;
